import { useEffect } from 'react';
import { useNonRevalidatingFetcher } from '../useNonRevalidatingFetcher';

import type { RecommendedPost } from '~/interfaces/recommended_post';

type FetcherData = {
  recommendedPosts: RecommendedPost[];
};

const useRecommendedPosts = (postId: string, isEnabled = true) => {
  const fetcher = useNonRevalidatingFetcher<() => Promise<FetcherData>>();

  useEffect(() => {
    if (postId && isEnabled) {
      fetcher.load(`/recommended_posts?post_id=${postId}`);
    }
  }, [postId]);

  return fetcher?.data?.recommendedPosts || [];
};

export default useRecommendedPosts;
